// extracted by mini-css-extract-plugin
export default {"root":"S83UOn","ArrowsMenuButtonSkin":"hwwIth","arrowsMenuButtonSkin":"hwwIth","linkElement":"at1V2a","arrowHead":"nprpN5","arrowTail":"mdft41","label":"D05boL"};